<script setup lang="ts">
import { Switch } from '@headlessui/vue'
import LoadingIcon from '../Utils/LoadingIcon.vue';

const props = defineProps<{
    modelValue: boolean
    classes?: string
    disabled?: boolean
    isLoading?: boolean
}>()

const emit = defineEmits<{
    (e: 'update:modelValue', value: boolean): void
}>()

</script>


<template>
    <Switch
        :modelValue="modelValue"
        @update:modelValue="(val) => emit('update:modelValue', val)"
        :class="[
            modelValue ? 'bg-sky-600' : 'bg-gray-300',
            disabled ? 'opacity-50' : 'opacity-100',
            classes,
        ]"
        class="pr-1 relative inline-flex h-6 w-12 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-all focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
    >
        <!-- <span class="sr-only">Use setting</span> -->
        <span aria-hidden="true"
            class="relative pointer-events-none text-xs h-full w-1/2 transform rounded-full bg-white shadow-lg ring-0 transition duration-200 ease-in-out"
            :class="[
                
                modelValue ? 'translate-x-6' : 'translate-x-0']
            "
        >
            <span class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 flex items-center justify-center">
                <LoadingIcon v-if="isLoading" class="" />
            </span>
        </span>
    </Switch>
</template>